import themeVariables from "@Theme/exportColor.module.scss";

const ArrowIconBlack = ({
  stroke = themeVariables.fontColorDark4,
  width = "14",
  height = "14",
  viewBox = "0 0 14 8",
  strokeWidth = "1.4",
  rotate = 0,
  className = "",
  transform = "translate(-385 -47)",
}: any) => (
  <svg
    style={rotate ? { transform: `rotate(${rotate}deg)` } : {}}
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
  >
    <path
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M386 48L392 54 398 48"
      transform={transform}
    />
  </svg>
);

export default ArrowIconBlack;
